import { Modal } from '../FormComponents';
import { THEME, COLORS } from '../colors';

interface UninvitedUserModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirmation modal shown when a user tries to sign up without being invited
 * Warns them that they weren't invited by a videographer and asks if they want to proceed
 */
export function UninvitedUserModal({
  isOpen,
  onConfirm,
  onCancel,
}: UninvitedUserModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      size="md"
      theme="light"
      backdropOpacity={0.3}
      title="Are you sure?"
    >
      <div style={{ paddingLeft: '40px', paddingRight: '40px', paddingBottom: '32px' }}>
        <div style={{ marginBottom: '32px' }}>
          <p style={{ color: THEME.light.text.primary, fontSize: '16px', lineHeight: '1.6' }}>
            You were not invited by a videographer. Do you still want to join Vinividi?
          </p>
          <p style={{ color: THEME.light.text.tertiary, fontSize: '14px', lineHeight: '1.6', marginTop: '12px' }}>
            If you received an invitation, please check that you're using the correct email address.
          </p>
        </div>

        <div style={{ display: 'flex', gap: '16px', justifyContent: 'flex-end' }}>
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onCancel();
            }}
            style={{
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: '500',
              color: THEME.light.text.primary,
              backgroundColor: THEME.light.background.tertiary,
              borderRadius: '6px',
              border: 'none',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = COLORS.primary[200]}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = THEME.light.background.tertiary}
          >
            Go Back
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onConfirm();
            }}
            style={{
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: '500',
              color: THEME.interactive.primary.text,
              backgroundColor: THEME.interactive.primary.main,
              borderRadius: '6px',
              border: 'none',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = THEME.interactive.primary.active}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = THEME.interactive.primary.main}
          >
            Join Anyway
          </button>
        </div>
      </div>
    </Modal>
  );
}
